export enum FinanceType {
  CASH = `cash`,
  CONCERT = `concert`,
  CREDIT_HUMAN = `credit_human`,
  LIGHT_REACH = `lightreach`,
  GOODLEAP = `goodleap`,
  ENFIN = `enfin`,
  SUNGAGE = `sungage`,
}

export enum FundingGroup {
  LightReachPPA = `LightReach Predictable PPA`,
  LightReachLease = `LightReach Solar Lease`,
  GoodleapTpo = `Goodleap - TPO`,
  GoodleapLease = `Goodleap - Loan`,
  EnfinTpo = `Enfin - TPO`,
  SungageBrightStar = `Sungage - BrightStar`,
  SungageSunriseEscalator = `Sungage - Sunrise Escalator`,
}

export const MIN_PROPOSAL_MARGIN = 0
export const MAX_PROPOSAL_MARGIN = 4
